import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#student-payment-calculator-app', App);
